/**
 * 模块：系统事件报警
 * 作者：haikuo.zhang
 * 时间：2021-09-14
 */

import * as systemEventConst from './constants';

export default {
    [systemEventConst.DescribeInstanceSystemEvents](state, data) {
        state.list = data.sysEventGroupList;
        state.total = data.totalCount;
    },
    //选中的tag和属性项
    [systemEventConst.colsChecked](state, res) {
        state.listChecked = res.listChecked;
    },

};
